import { useHistory, useParams } from 'react-router-dom';
import { SiteGroupForm } from './siteGroupForm';
import { useState } from 'react';
import api from '../api/api';

export default function AddSiteGroup(props) {
    const history = useHistory();

    const {clientId, siteId} = useParams();
    const [name, setName] = useState("");
    const [numberOfSessions, setNumberOfSessions] = useState("");
    const [notes, setNotes] = useState("");
    const [concurrentLimitEnabled, setConcurrentLimitEnabled] = useState(false);
    const [maxAllowListEnabled, setMaxAllowListEnabled] = useState(false);
    const [maximumNumberOfAllowListEntries, setMaximumNumberOfAllowListEntries] = useState("");

    const siteUrl = `/organisation/${props.organisationId}/client/${clientId}/site/${siteId}`

    const handleSubmit = () => {
        api.addSiteGroup(
            props.organisationId, siteId, 
            name,
            concurrentLimitEnabled ? Number(numberOfSessions) : null,
            maxAllowListEnabled ? Number(maximumNumberOfAllowListEntries) : null,
            notes,
            () => history.push(siteUrl),
            error => console.log(error),
            props.token
        )
    }
    
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="mb-0">Add New Group</h5>
                                </div>
                            </div>
                        </div>
                        <SiteGroupForm 
                            name={name}
                            setName={setName}
                            notes={notes}
                            setNotes={setNotes}
                            numberOfSessions={numberOfSessions}
                            setNumberOfSessions={setNumberOfSessions}
                            concurrentLimitEnabled={concurrentLimitEnabled}
                            setConcurrentLimitEnabled={setConcurrentLimitEnabled}
                            maxAllowListEnabled={maxAllowListEnabled}
                            setMaxAllowListEnabled={setMaxAllowListEnabled}
                            maximumNumberOfAllowListEntries={maximumNumberOfAllowListEntries}
                            setMaximumNumberOfAllowListEntries={setMaximumNumberOfAllowListEntries}
                            onCancel={() => history.push(siteUrl)}
                            onSubmit={() => handleSubmit()}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}